module.exports = __webpack_public_path__ + "static/media/SIM_Consent_Process_pdf.e51b0f83.pdf";